import { httpPut } from "../../../../../common/network/fetch";

export const ConfirmSupplierContactDataValidation = async () => {
    return await httpPut({ url: `/user-data/valid` });
};
